import { render, staticRenderFns } from "./IndexKlaimCCPp.vue?vue&type=template&id=96a236e6&"
import script from "./IndexKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./IndexKlaimCCPp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports